<template>
  <div class="form-group last">
    <h5> {{ name }} </h5>

    <div class="anx-select">
      <span class="error"> {{ choosedExchangesData[0].error }} </span><br>
      <label
        :id="idIP4"
        for="selectIPv4"
      >
        IPv4*
      </label>
      <select
        id="selectIPv4"
        v-model="updateChoosedExchangesIPv4"
      >
        <option
          v-for="(ip,id) in exchangesData[0].ipaddr4"
          :key="id"
          :value="ip"
        >
          {{ ip }}
        </option>
      </select>
    </div>


    <div class="anx-select">
      <label
        :id="idIP6"
        for="selectIPv6"
        class="mt-5"
      >IPv6</label>
      <select
        id="selectIPv6"
        v-model="updateChoosedExchangesIPv6"
        class="custom-select mr-sm-2"
      >
        <option
          v-for="(ip,id) in exchangesData[0].ipaddr6"
          :key="id"
          :value="ip"
        >
          {{ ip }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import * as label from "./script/label.js";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";

export default {
  name: "Exchange",
  components: {},
  props: {
    name: {
      type: String,
      default: ""
      }
  },
  data(){
    return {
      idIP4: this.name +"4",
      idIP6: this.name +"6",
    }
  },
  computed: {
    exchangesData() {
        return this.$store.getters.getIXByName(this.name);
    },
    choosedExchangesData() {
      return this.$store.getters.getChoosedIXByName(this.name);
    },

    updateChoosedExchangesIPv4: {
      get() {
        return this.choosedExchangesData[0].ip4;
      },
      set(value) {
        var data = { value, name: this.name };
        this.$store.commit("setFormDataChoosedExchangesIP4", data);
        label.labelChangeClass(this.idIP4, value);
      }
    },

    updateChoosedExchangesIPv6: {
      get() {
        return this.choosedExchangesData[0].ip6;
      },
      set(value) {
        var data = { value, name: this.name };
        this.$store.commit("setFormDataChoosedExchangesIP6", data);
        label.labelChangeClass(this.idIP6, value);
      }
    }
  },
  created() {
    this.$store.commit("setFormDataChoosedExchangesEntries", this.name);
  },
  mounted(){
    if(this.choosedExchangesData[0].ip4[0].length > 0){
      label.labelChangeClass(this.idIP4, "x");
    }
    if(this.choosedExchangesData[0].ip6[0] > 0 ){
      label.labelChangeClass(this.idIP6, "x");
    }
  },
  beforeDestroy(){
    this.$store.commit("deleteChoosedExchangesEntries", this.name);
  }
};
</script>

<style lang="scss" scoped>
@import "./less/anx-select.scss";

.vee-select {
  padding: 0;

  > div {
    margin-bottom: 40px;
  }
}

.form-group {
  background-color: white;
  color: black;
  padding: 40px;
  height: fit-content;
}

span.anx-select{

  padding: 0px;
  margin-bottom: 30px;

}
</style>
